// Import the functions you need from the SDKs you need
import { initializeApp } from "@firebase/app";
import { getAnalytics } from "@firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHb6cpAPTVFjUfJJ4z2c34uH04HZOULkg",
  authDomain: "sehatechllc-e8aa2.firebaseapp.com",
  projectId: "sehatechllc-e8aa2",
  storageBucket: "sehatechllc-e8aa2.appspot.com",
  messagingSenderId: "830047792855",
  appId: "1:830047792855:web:b7ce3c161d1050fcf68a92",
  measurementId: "G-QSJ4N8G0RY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);


export {analytics, storage}